/**
 * Phone number length configuration per dial code.
 * Key: dialCode (e.g. "+91")
 * Value: exact digit count OR [min, max] range (excluding the dial code itself)
 */
export const PHONE_LENGTH_BY_DIAL_CODE: Record<string, number | [number, number]> = {
  "+93": [8, 9],       // Afghanistan
  "+355": [8, 9],      // Albania
  "+213": 9,           // Algeria
  "+376": [6, 9],      // Andorra
  "+244": 9,           // Angola
  "+1-268": 7,         // Antigua and Barbuda
  "+54": [6, 11],      // Argentina
  "+374": 8,           // Armenia
  "+61": 9,            // Australia
  "+43": [4, 12],      // Austria
  "+994": 9,           // Azerbaijan
  "+1-242": 7,         // Bahamas
  "+973": 8,           // Bahrain
  "+880": 10,          // Bangladesh
  "+1-246": 7,         // Barbados
  "+375": [9, 10],     // Belarus
  "+32": [8, 9],       // Belgium
  "+501": 7,           // Belize
  "+229": 8,           // Benin
  "+975": 8,           // Bhutan
  "+591": 8,           // Bolivia
  "+387": [8, 9],      // Bosnia and Herzegovina
  "+267": [7, 8],      // Botswana
  "+55": [10, 11],     // Brazil
  "+673": 7,           // Brunei
  "+359": [7, 9],      // Bulgaria
  "+226": 8,           // Burkina Faso
  "+257": 8,           // Burundi
  "+855": [8, 9],      // Cambodia
  "+237": 9,           // Cameroon
  "+1": 10,            // Canada / US
  "+238": 7,           // Cape Verde
  "+236": 8,           // Central African Republic
  "+235": 8,           // Chad
  "+56": 9,            // Chile
  "+86": 11,           // China
  "+57": 10,           // Colombia
  "+269": 7,           // Comoros
  "+506": 8,           // Costa Rica
  "+385": [8, 9],      // Croatia
  "+53": 8,            // Cuba
  "+357": 8,           // Cyprus
  "+420": 9,           // Czech Republic
  "+243": 9,           // Congo (DRC)
  "+242": 9,           // Congo (Republic)
  "+225": 10,          // Côte d'Ivoire
  "+45": 8,            // Denmark
  "+253": 8,           // Djibouti
  "+1-767": 7,         // Dominica
  "+1-809": 7,         // Dominican Republic
  "+593": 9,           // Ecuador
  "+20": 10,           // Egypt
  "+503": 8,           // El Salvador
  "+240": 9,           // Equatorial Guinea
  "+291": 7,           // Eritrea
  "+372": [7, 8],      // Estonia
  "+268": 8,           // Eswatini
  "+251": 9,           // Ethiopia
  "+679": 7,           // Fiji
  "+358": [6, 11],     // Finland
  "+33": 9,            // France
  "+241": [7, 8],      // Gabon
  "+220": 7,           // Gambia
  "+995": 9,           // Georgia
  "+49": [6, 12],      // Germany
  "+233": 9,           // Ghana
  "+30": 10,           // Greece
  "+502": 8,           // Guatemala
  "+224": 9,           // Guinea
  "+245": 7,           // Guinea-Bissau
  "+592": 7,           // Guyana
  "+509": 8,           // Haiti
  "+504": 8,           // Honduras
  "+852": 8,           // Hong Kong
  "+36": 9,            // Hungary
  "+354": 7,           // Iceland
  "+91": 10,           // India
  "+62": [9, 12],      // Indonesia
  "+98": 10,           // Iran
  "+964": 10,          // Iraq
  "+353": [7, 9],      // Ireland
  "+972": 9,           // Israel
  "+39": [6, 11],      // Italy
  "+1-876": 7,         // Jamaica
  "+81": [9, 10],      // Japan
  "+962": 9,           // Jordan
  "+7": 10,            // Kazakhstan / Russia
  "+254": 9,           // Kenya
  "+965": 8,           // Kuwait
  "+996": 9,           // Kyrgyzstan
  "+856": [8, 10],     // Laos
  "+371": 8,           // Latvia
  "+961": [7, 8],      // Lebanon
  "+266": 8,           // Lesotho
  "+231": [7, 8],      // Liberia
  "+218": 9,           // Libya
  "+423": 7,           // Liechtenstein
  "+370": 8,           // Lithuania
  "+352": [4, 11],     // Luxembourg
  "+261": 9,           // Madagascar
  "+265": 9,           // Malawi
  "+60": [9, 10],      // Malaysia
  "+960": 7,           // Maldives
  "+223": 8,           // Mali
  "+356": 8,           // Malta
  "+222": 8,           // Mauritania
  "+230": 8,           // Mauritius
  "+52": 10,           // Mexico
  "+691": 7,           // Micronesia
  "+373": 8,           // Moldova
  "+377": [8, 9],      // Monaco
  "+976": 8,           // Mongolia
  "+382": [8, 9],      // Montenegro
  "+212": 9,           // Morocco
  "+258": 9,           // Mozambique
  "+95": [7, 10],      // Myanmar
  "+264": [7, 9],      // Namibia
  "+977": 10,          // Nepal
  "+31": 9,            // Netherlands
  "+64": [8, 10],      // New Zealand
  "+505": 8,           // Nicaragua
  "+227": 8,           // Niger
  "+234": 10,          // Nigeria
  "+47": 8,            // Norway
  "+850": [8, 10],     // North Korea
  "+389": 8,           // North Macedonia
  "+968": 8,           // Oman
  "+92": 10,           // Pakistan
  "+507": [7, 8],      // Panama
  "+675": 8,           // Papua New Guinea
  "+595": 9,           // Paraguay
  "+51": 9,            // Peru
  "+63": 10,           // Philippines
  "+48": 9,            // Poland
  "+351": 9,           // Portugal
  "+970": 9,           // Palestine
  "+974": 8,           // Qatar
  "+40": 9,            // Romania
  "+250": 9,           // Rwanda
  "+966": 9,           // Saudi Arabia
  "+221": 9,           // Senegal
  "+381": [8, 9],      // Serbia
  "+248": 7,           // Seychelles
  "+232": 8,           // Sierra Leone
  "+65": 8,            // Singapore
  "+421": 9,           // Slovakia
  "+386": 8,           // Slovenia
  "+252": [7, 8],      // Somalia
  "+27": 9,            // South Africa
  "+82": [9, 10],      // South Korea
  "+211": 9,           // South Sudan
  "+34": 9,            // Spain
  "+94": 9,            // Sri Lanka
  "+249": 9,           // Sudan
  "+597": [6, 7],      // Suriname
  "+46": [7, 13],      // Sweden
  "+41": 9,            // Switzerland
  "+963": 9,           // Syria
  "+886": 9,           // Taiwan
  "+992": 9,           // Tajikistan
  "+255": 9,           // Tanzania
  "+66": 9,            // Thailand
  "+228": 8,           // Togo
  "+1-868": 7,         // Trinidad and Tobago
  "+216": 8,           // Tunisia
  "+90": 10,           // Turkey
  "+993": 8,           // Turkmenistan
  "+256": 9,           // Uganda
  "+380": 9,           // Ukraine
  "+971": 9,           // UAE
  "+44": [9, 10],      // United Kingdom
  "+598": [8, 9],      // Uruguay
  "+998": 9,           // Uzbekistan
  "+58": 10,           // Venezuela
  "+84": [9, 10],      // Vietnam
  "+967": 9,           // Yemen
  "+260": 9,           // Zambia
  "+263": 9,           // Zimbabwe
  "+1-473": 7,         // Grenada
};


// ============================================
// VALIDATION UTILITIES
// ============================================

/**
 * Get expected phone number length for a given dial code.
 * Returns the config or defaults to [7, 15] if not found.
 */
export const getPhoneLength = (dialCode: string): number | [number, number] => {
  return PHONE_LENGTH_BY_DIAL_CODE[dialCode] || [7, 15];
};

/**
 * Get the maximum allowed phone digits for input restriction.
 */
export const getMaxPhoneLength = (dialCode: string): number => {
  const len = getPhoneLength(dialCode);
  return typeof len === "number" ? len : len[1];
};

/**
 * Get the minimum required phone digits.
 */
export const getMinPhoneLength = (dialCode: string): number => {
  const len = getPhoneLength(dialCode);
  return typeof len === "number" ? len : len[0];
};

/**
 * Validate phone number length for a given dial code.
 * @param dialCode - Country dial code (e.g. "+91")
 * @param phoneNumber - The phone number digits (without dial code)
 * @returns Validation result with details
 */
export const validatePhoneNumber = (
  dialCode: string,
  phoneNumber: string,
): { isValid: boolean; expectedLength: string; actualLength: number; error?: string } => {
  const digits = phoneNumber.replace(/\D/g, "");
  const actualLength = digits.length;
  const expected = getPhoneLength(dialCode);

  if (actualLength === 0) {
    return { isValid: false, expectedLength: formatExpected(expected), actualLength, error: "Phone number is required" };
  }

  if (typeof expected === "number") {
    const isValid = actualLength === expected;
    return {
      isValid,
      expectedLength: `${expected}`,
      actualLength,
      error: isValid ? undefined : `Phone number must be ${expected} digits`,
    };
  }

  const [min, max] = expected;
  const isValid = actualLength >= min && actualLength <= max;
  return {
    isValid,
    expectedLength: `${min}-${max}`,
    actualLength,
    error: isValid ? undefined : `Phone number must be ${min}-${max} digits`,
  };
};

/**
 * Format expected length for display.
 */
const formatExpected = (expected: number | [number, number]): string => {
  if (typeof expected === "number") return `${expected}`;
  return `${expected[0]}-${expected[1]}`;
};

/**
 * Get a display-friendly phone length hint.
 * e.g. "10 digits" or "9-10 digits"
 */
export const getPhoneLengthHint = (dialCode: string): string => {
  const expected = getPhoneLength(dialCode);
  if (typeof expected === "number") return `${expected} digits`;
  return `${expected[0]}-${expected[1]} digits`;
};
